import { gql } from 'graphql-request';
import { graphQLApi } from 'utils/Api';
import { UpdateEntriesResponse, UpdateOvertimeEntriesInput } from '../types';

const updateEntriesMutation = gql`
  mutation OvertimeUpdateEntries($input: UpdateOvertimeEntriesInput!) {
    overtimeUpdateEntries(input: $input) {
      code
      success
      message
      data {
        entries {
          id
          userId
          formulaCardId
          otFormulaCardName
          totalOtHours
          totalOtDays
          overrideAmount
          status
        }
      }
    }
  }
`;

const updateEntries = (queryVariables: { input: UpdateOvertimeEntriesInput }) => {
  return graphQLApi<UpdateEntriesResponse, { input: UpdateOvertimeEntriesInput }>({
    query: updateEntriesMutation,
    queryVariables,
  });
};

export default updateEntries;
